module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="pinning">\n	<button class="pin_photo"></button>\n	<div class="pin_buttons">\n		<button title="Previous" type="button" class="prev_pin"></button>\n		<button title="Next" type="button" class="next_pin"></button>\n	</div>\n</div>\n	';
 if (!isVideo()) { ;
__p += '\n	<div class="box_bg_image active slider" style="height:100%; width: 100%; background-image: url(\'' +
((__t = ( photoURL('xl') )) == null ? '' : __t) +
'\'); background-repeat:no-repeat; background-size: cover; opacity: 0; background-position:center center;" data-id="' +
((__t = ( album_photo_id )) == null ? '' : __t) +
'">\n	';
 } else {  ;
__p += '\n	<div class="box_bg_image active slider" style="height:100%; width: 100%; background-image: url(\'' +
((__t = ( getVideoThumbnailUrl() )) == null ? '' : __t) +
'\'); background-repeat:no-repeat; background-size: cover; opacity: 0; background-position:center center;" data-id="' +
((__t = ( album_photo_id )) == null ? '' : __t) +
'">\n	';
 } ;
__p += '\n		<div class="header-unit active slider" style="position:relative; ';
 if(!isVideo()){ ;
__p += ' display:none; ';
 };
__p += ' height:100%; width:100%;">\n			<div class="video-container" style="position:absolute; top:0%; left:0%; height:100%; width:100%; overflow: hidden;">\n				<video class="pixlee_video" src="';
 if(isVideo()){ ;
__p += ' ' +
((__t = ( videoUrl() )) == null ? '' : __t) +
' ';
 };
__p += '" muted style="position:absolute; z-index:0; top: 0px; left: 0px; min-width: 100%; min-height: 100%; width: 100%; height: 100%;">\n				</video>\n			</div>\n		    <div class="pixlee_youtube_video" style="position:absolute; top:0%; left:0%; height:100%; width:100%; overflow: hidden;">\n		       <div class="player" style="position:absolute; z-index:0; top: 0px; left: 0px; min-width: 100%; min-height: 100%; width: 100%; height: 100%;"></div>\n		    </div>\n		</div>\n	</div>\n	';
 if (!isVideo()) { ;
__p += '\n	<img class="box_image active" style="display:none;" src="' +
((__t = ( photoURL('xl') )) == null ? '' : __t) +
'" />\n	';
 } else {  ;
__p += '\n	<img class="box_image active" style="display:none;" src="' +
((__t = ( getVideoThumbnailUrl() )) == null ? '' : __t) +
'" />\n	';
 } ;
__p += '\n	<div class="box_bg_image slider" style="height:100%; width: 100%; background-repeat:no-repeat; background-size: cover; opacity: 0; background-position:center center;"  data-id="' +
((__t = ( album_photo_id )) == null ? '' : __t) +
'">\n		<div class="header-unit active slider" style="position:relative; ';
 if(!isVideo()){ ;
__p += ' display:none; ';
 };
__p += ' height:100%; width:100%;">\n			<div class="video-container" style="position:absolute; top:0%; left:0%; height:100%; width:100%; overflow: hidden;">\n				<video class="pixlee_video" src="';
 if(isVideo()){ ;
__p += ' ' +
((__t = ( videoUrl() )) == null ? '' : __t) +
' ';
 };
__p += '" muted style="position:absolute; z-index:0; top: 0px; left: 0px; min-width: 100%; min-height: 100%; width: 100%; height: 100%;">\n				</video>\n			</div>\n		    <div class="pixlee_youtube_video" style="position:absolute; top:0%; left:0%; height:100%; width:100%; overflow: hidden;">\n		       <div class="player" style="position:absolute; z-index:0; top: 0px; left: 0px; min-width: 100%; min-height: 100%; width: 100%; height: 100%;"></div>\n		    </div>\n		</div>\n	</div>\n	<img class="box_image" style="display:none;" src="" />';

}
return __p
}